import { getStoreUrl } from "../store/utils"
import { contributorsManageToolbar } from "./toolbar"
const { createCardRoutes } = require("lib/core/routing/card-routing")
const { loadAuthors, selectAuthor, unselectAuthor } = require("./middleware")

const AuthorListCard = require("./list/AuthorListCard").default
const AuthorFormCard = require("./item/AuthorFormCard").default

// HACK: for "passing" /client/main components to /client/features
window.contributorsManageToolbar = contributorsManageToolbar

export const cardRoutes = {
  author: {
    component: AuthorListCard,
    middleware: loadAuthors,
    getDefaultLaunchedFrom: () => getStoreUrl(),
    childCards: {
      item: {
        path: ":authorId(\\d+|new)/",
        middleware: selectAuthor,
        leaveMiddleware: unselectAuthor,
        component: AuthorFormCard
      }
    }
  }
}

const fallbackComponent = require("store/StoreOrLibraryBrowse").default

export default createCardRoutes("/manage/", cardRoutes, fallbackComponent)
